<template>
  <div class="main-container vip">
    <div class="vip-top">
      <template v-if="!isLogin">
        <div class="avatar">
          <img src="@/assets/images/vip/noLogin@3x.png" alt="" />
        </div>
        <div class="user-info">
          <div class="login-button">
            <span
              style="cursor: pointer"
              @click="$LoginModal.login({ type: 'passwordLogin' })"
            >
              {{ $t("common.login") }}
            </span>
            <span>/</span>
            <span
              style="cursor: pointer"
              @click="$LoginModal.login({ type: 'register', store: $store })"
            >
              注册
            </span>
          </div>
          <div class="vip-info">登录后查看</div>
        </div>
      </template>
      <template v-else>
        <div class="avatar">
          <img :src="$store.state.user_info.avatar" alt="" />
        </div>
        <div class="user-info">
          <div class="user">
            <span>{{ $store.state.user_info.nickname }}</span>
            <img
              :src="userInfo.icon_url"
              alt=""
              v-if="userInfo.name && !getIsExpire(userInfo.end_at)"
            />
            <img :src="iconUrl" alt="" v-else />
          </div>
          <div class="vip-info">
            <span>
              {{ userInfo.name || "暂未开通，快去开通会员享受会员特权吧~" }}
            </span>
            <span
              style="margin-left: 10px"
              v-if="userInfo.name && !getIsExpire(userInfo.end_at)"
            >
              有效期至 {{ userInfo.end_at | tsFormatLong }}
            </span>
            <span
              style="margin-left: 10px"
              v-if="userInfo.name && getIsExpire(userInfo.end_at)"
            >
              已过期
            </span>
          </div>
        </div>
      </template>
      <div class="vip-back">
        <img src="@/assets/images/vip/back@3x.png" alt="" />
      </div>
    </div>
    <div class="vip-content">
      <LevelTabs @callBack="callBack" />
      <div class="vip-class" v-if="vipType && vipType.length > 0">
        <div class="vip-title">开通时长</div>
        <div class="swiper-content">
          <swiper :options="swiperOption" ref="mySwiper">
            <!-- slides -->
            <swiper-slide
              v-for="(item, index) in vipType"
              :key="index"
              style="width: auto"
            >
              <VipCard class="card" :vipInfo="item" />
            </swiper-slide>
            <div
              class="swiper-button swiper-button-next"
              slot="button-prev"
              v-show="vipType && vipType.length > 5"
            ></div>
            <div
              class="swiper-button swiper-button-prev"
              slot="button-next"
              v-show="vipType && vipType.length > 5"
            ></div>
          </swiper>
        </div>
        <div class="vip-describe">
          注：一个月=30天，一个季度=90天，一年=365天；
        </div>
        <div class="vip-describe">
          会员还在有效期内时不支持开通更低等级会员，开通更高等级会员时有效期从当前日期开始计算，原会员剩余有效期将按实付金额折算抵扣。
        </div>
        <div v-if="treaty" class="vip-describe">
          开通代表您已阅读并同意
          <span @click="showModal = true" class="treaty">《会员协议》</span>
        </div>
      </div>
      <div
        class="vip-class"
        style="margin-top: 26px"
        v-if="courseList && courseList.length > 0"
      >
        <div class="vip-title">
          会员课程
          <span class="more" v-if="isMore" @click="showMore">查看更多 ></span>
        </div>
        <div class="vip-course">
          <div>
            <template v-for="course in courseList">
              <RichCourseItem
                :key="course.id"
                :course="course"
              ></RichCourseItem>
            </template>
          </div>
        </div>
      </div>
      <div class="vip-class" v-if="vipInfo.content">
        <div class="vip-title">会员介绍</div>
        <div class="vip-introduce">
          <div class="tab-content-detail">
            <Rich id="course-detail" v-html="vipInfo.content"></Rich>
          </div>
        </div>
      </div>
      <EmptyNew v-else title="暂无会员介绍"></EmptyNew>
    </div>
    <TreatyModal :showModal.sync="showModal" />
  </div>
</template>

<script>
import LevelTabs from "./components/LevelTabs";
import VipCard from "./components/VipCard";
import { VipLevelType } from "@/utils/enums.js";
import TreatyModal from "./components/TreatyModal";
import RichCourseItem from "../../components/rich/CourseItem.vue";
import EmptyNew from "@/components/EmptyNew.vue";

export default {
  name: "Vip",
  components: {
    LevelTabs,
    VipCard,
    TreatyModal,
    RichCourseItem,
    EmptyNew,
  },
  data() {
    return {
      courseList: [],
      swiperOption: {
        //滑动
        slidesPerView: "auto",
        spaceBetween: 24,
        initialSlide: 0,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      userInfo: {},
      vip_id: "",
      vipInfo: {},
      vipType: [],
      isMore: false, //是否展示更多
      showModal: false, //会员协议modal
    };
  },
  async created() {
    const res = await this.$http.get("/api/app/vip/user_info");
    this.userInfo = res;
  },
  computed: {
    isLogin() {
      return this.$store.state.token;
    },
    iconUrl() {
      return this.$store.state.commonSetting.not_vip_icon;
    },
    //会员协议是否开启
    treaty() {
      return (
        this.$store.state.commonSetting.treaty_state &&
        this.$store.state.commonSetting.treaty_state == 1
      );
    },
  },
  methods: {
    //查看更多会员课程
    showMore() {
      this.$router.push({
        name: "Course",
        query: { vip: true, vip_id: this.vip_id },
      });
    },
    // //只展示最多三个会员课程
    // getCourseList() {
    //   if (this.courseList && this.courseList.length > 3) {
    //     return this.courseList.slice(0, 3);
    //   }
    //   return this.courseList;
    // },
    // //获取相应的会员课程
    // async getCourse() {
    //   const data = await this.$http.get("/api/app/courseBasis", {
    //     is_vip: 1,
    //     vip_id: this.vip_id,
    //   });
    //   this.courseList = data.data || [];
    // },
    //数据传递  会员等级id,会员等级数据
    async callBack(id, value) {
      this.vip_id = id;
      this.vipInfo = value || {};
      this.vipType = this.vipInfo.price_data.map(i => ({
        ...i,
        typeName: VipLevelType.getValue(i.type),
      }));
      this.courseList = this.vipInfo.vipCourse.list || [];
      // const courseDiscount = this.vipInfo.attr_data.vip_key_course_discount;
      this.isMore =
        this.vipInfo.vipCourse.total && this.vipInfo.vipCourse.total > 3;
    },
    //判断会员是否过期
    getIsExpire(time) {
      if (time) {
        const now = this.$actionTool.getCurTimestamp(); //当前时间的时间戳
        if (now > time) {
          //如果当前时间大于会员到期时间，说明已过期
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.vip {
  margin-top: 20px;
  padding-bottom: 30px;
  .vip-top {
    overflow: hidden;
    box-sizing: border-box;
    width: 100%;
    height: 120px;
    padding: 20px 24px;
    background: linear-gradient(90deg, #ecc489, #f3dfc0 100%);
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    .avatar {
      width: 72px;
      height: 72px;
      margin-top: 5px;
      img {
        border-radius: 50%;
        width: 72px;
        height: 72px;
      }
    }
    .user-info {
      padding: 0 24px;
      .login-button {
        padding-top: 14px;
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: #6b440c;
        line-height: 26px;
        height: 26px;
      }
      .vip-info {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #896a3e;
        line-height: 28px;
        margin-top: 4px;
        width: 800px;
      }
      .user {
        padding-top: 14px;
        height: 25px;
        span {
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: #6b440c;
          vertical-align: middle;
        }
        img {
          margin-left: 12px;
          width: 25px;
          height: 25px;
          vertical-align: middle;
        }
      }
    }
    .vip-back {
      margin-top: 10px;
      margin-left: 20px;
      img {
        width: 125px;
        height: 119px;
      }
    }
  }
  .vip-content {
    background: #fff;
    border-radius: 8px;
    margin-top: 14px;
    padding: 10px 24px 24px 24px;
    .vip-class {
      margin-top: 40px;
      .vip-title {
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #333333;
        position: relative;
      }
      .more {
        position: absolute;
        top: 0;
        right: 3px;
        height: 22px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
        cursor: pointer;
      }
      .vip-course {
        height: 300px;
        margin-top: 17px;
        /deep/ .item {
          margin-bottom: 0;
          // width: 364px;
          // height: 430px;
          margin-right: 30px;
          &:last-child {
            margin-right: 0;
          }
        }
        /deep/ .title-wrap {
          margin-bottom: 4px;
        }
        /deep/ .course-footer {
          bottom: 18px;
        }
        /deep/ .container.cover {
          // width: 362px !important;
          // height: 238px !important;
          margin-bottom: 16px;
          /deep/ img {
            width: 362px !important;
            height: 238px !important;
          }
        }
      }
      .vip-card-content {
        margin-top: 16px;
        display: flex;
        flex-direction: row;
        .card {
          width: 184px;
          margin-right: 24px;
        }
      }
      .card {
        width: 184px;
        //margin-right: 24px;
      }
      .swiper-content {
        //margin-top: 1px;
        position: relative;
        /deep/ .swiper-container {
          padding: 16px 0 24px 0;
          //overflow-y: auto;
          //overflow: auto;
          //overflow-x: hidden;
        }
        /deep/ .swiper-button {
          width: 28px;
          height: 40px;
          position: absolute;
          background-size: 100% 100%;
          z-index: 9999;
        }

        /deep/ .swiper-button-prev {
          background-image: url("~@/assets/images/vip/prev.png");
          left: 0;
        }
        /deep/ .swiper-button-next {
          background-image: url("~@/assets/images/vip/next.png");
          right: 0;
        }
      }
    }
    .vip-describe {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #999999;
      line-height: 22px;
      .treaty {
        color: $primary-color;
        cursor: pointer;
      }
      .treaty:hover {
        color: $primary-color-hover;
      }
    }
    .vip-introduce {
      margin-top: 16px;
      width: 100%;
      background: #fcfaf4;
      border-radius: 8px;
      padding: 30px 20px;
      box-sizing: border-box;
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #333333;
      img {
        max-width: 1112px;
      }
    }
  }
}
</style>
